export default __webpack_public_path__ + "static/media/Smart_wall_switch_01.d0d42b90.svg";